// Keeping an invite link's code across sign-in. A signed-out visitor who opens
// `https://groundteam.netlify.app/welcome#code=…` is redirected to /sign-in by the route guard, and the fragment is lost on
// the way. A guard can call `stashInviteCode(location.hash)` before it redirects; /welcome reads it back once. The code
// works like a password, so it lives in sessionStorage (this tab only, gone when the tab closes) and is removed when read.

import { readInviteLink } from './inviteCode';

const KEY = 'gt:welcome:inviteCode';

function session(): Storage | null {
  try {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage;
  } catch {
    return null;
  }
}

/** Remembers the `#code=…` of `hash` for /welcome (nothing when the hash has no code). */
export function stashInviteCode(hash: string): void {
  const { code } = readInviteLink(hash);
  if (!code) return;
  try {
    session()?.setItem(KEY, code);
  } catch {
    // No storage: the person types the code instead.
  }
}

/** The stashed code, once. */
export function takeStashedInviteCode(): string | null {
  try {
    const s = session();
    const code = s?.getItem(KEY) ?? null;
    if (code !== null) s?.removeItem(KEY);
    return code && code.trim() !== '' ? code : null;
  } catch {
    return null;
  }
}
